import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import * as $ from 'jquery';
import * as _ from 'lodash';
import { StateService } from '@uirouter/angular';
import { UserRest } from '../../../core/services/core.user.rest.service';
import { PollService } from '../../../core/services/core.poll.service';
import { UserService } from '../../../core/services/core.user.service';
import { NotificationService } from '../../../core/services/core.notification.service';
import { GfTitleService } from '../../../core/services/core.title.service';

@Component({
    selector: 'sa-chat-view',
    template: require('./sachat.component.html')
})
export class StandaloneChatViewComponent implements OnInit, OnDestroy {

    @Input() siteConfig: any = null;

    // The CURRENT chatroom is the one being displayed right now
    currentChatroom = false;

    // The ACTIVE chatrooms are all rooms in the "Active" list, 
    // being polled and available for immediate display
    activeChatrooms = [];

    // The RECENT chatrooms are no longer being polled
    recentChatrooms = [];

    currentUserDetails = null;
    userProjects = [];
    userOrgs = [];
    chatrooms = null;
    headerEnabled = false;
    currentUser = null;
    siteName = '';
    isSiteAdmin = false;
    projectAdminCache = {};

    constructor(
        private httpClient: HttpClient,
        private window: Window,
        private userRest: UserRest,
        private pollService: PollService,
        private userService: UserService,
        private notificationService: NotificationService,
        private stateService: StateService,
        private titleService: GfTitleService
    ) { }

    ngOnInit() {
        if (!this.userService.session.hasUser()) {
            this.sendToLogin();
        }

        this.pollService.subscribe('session-check', (args) => {
            if (!args.response) {
                console.log("PollService returned a failure response", args);
                this.sendToLogin();
            }
        });

        this.currentUser = this.userService.session.getUser();
        this.siteName = _.get(this.siteConfig, 'siteName', 'GForge Next');
        this.isSiteAdmin = this.userService.session.isSiteAdmin();

        //get projects
        this.userRest.getProjects(this.currentUser.unixName, { isOrg: 0, sort_field: 'activity' })
            .then((data) =>  {
                this.userProjects = _.sortBy(_.map(_.get(data, 'items', []), this.mapProject), ['name']);
            }, (response) => {
                console.log('getProjects fail', response);
            });

        this.userRest.getProjects(this.currentUser.unixName, { isOrg: 1, sort_field: 'activity' })
            .then((data) =>  {
                this.userOrgs = _.sortBy(_.map(_.get(data, 'items', []), this.mapProject), ['name']);
            }, (response) => {
                console.log('getProjects fail', response);
            });

        //get recent
        this.userRest.getFull(this.currentUser.unixName, 'chat')
            .then((data) =>  {
                this.currentUserDetails = data;
                
                this.activeChatrooms = _.sortBy(
                    this.getChatroomData(data, true)
                        .map(this.mapChatroom),
                    ['name']
                );

                this.recentChatrooms = _.sortBy(
                    this.getChatroomData(data, false)
                        .map(this.mapChatroom),
                    ['name']
                );

                // Start the first active chatroom, if there is one.
                const firstActive = _.get(this.activeChatrooms, '[0]');
                if (firstActive) {
                    this.goChatroom(firstActive);
                }
            }, (response) => { console.log('getFull fail', response) });

        this.notificationService.subscribe('sachat', 'GFCHAT-USER-MENTION', (args) => {
            // TODO find the existing chatroom object first
            var t = this.findChatroom({section: args.section, refId: args.refId});
            if (t) {
                this.goChatroom(t);
            }
        });

        this.notificationService.subscribe('sachat', 'GFCHAT-HEADER-TOGGLE', (args) => {
            this.headerEnabled = args.headerEnabled;
        });        
    }

    ngOnDestroy() {
        this.notificationService.unsubscribe('sachat', 'GFCHAT-USER-MENTION');
        this.notificationService.unsubscribe('sachat', 'GFCHAT-HEADER-TOGGLE');
        this.pollService.unsubscribe('session-check');
    }

    sendToLogin() {
        this.window.location.href = '/user/login?url=%2Fchat';
    }

    mapProject(p) {
        return {
            id: 'project-' + p.id,
            section: 'project',
            refId: p.id,
            current: false,
            // Until this room's permissions are read, assume the lesser right.
            isAdmin: false,
            name: p.name
        };
    }
    
    mapChatroom(t, idx) {
        return {
            id: t.forum.section + '-' + t.forum.refId,
            threadId: t.id,
            section: t.forum.section,
            refId: t.forum.refId,
            name: t.forum.forumName,
            // Max of 5 active threads
            active: idx < 5 ? t.active : false,
            current: false,
            isAdmin: false
        };
    }
    
    getChatroomData(data, active) {
        return _.uniqBy(_.filter(
            _.get(data, 'rel.chat.openThreads', []),
            { active: active }
        ), 'id');
    }

    getAllChatrooms(): any {
        return this.activeChatrooms.concat(this.recentChatrooms, this.userProjects, this.userOrgs);
    }

    getActiveAndRecent(): any {
        return this.activeChatrooms.concat(this.recentChatrooms);
    }

    findChatroom(match: any) {
        return _.find(
            this.getAllChatrooms(), match
        );
    };

    setChatroomActive(t, active = true) {
        const all = this.getAllChatrooms();
        const tt = _.find(all, { id: t.id });
        tt.active = active;

        this.activeChatrooms = _.sortBy(_.uniqBy(
            _.filter(
                all, { active: true }
            ), 'id'
        ), ['name']);

        this.recentChatrooms = _.sortBy(_.uniqBy(
            _.filter(
                all, { active: false }
            ), 'id'
        ), ['name']);
    }

    //Creates/Switches to the project chatroom directive
    goChatroom(t, $ev?) {

        if ($ev) {
            $ev.stopPropagation();
            $ev.preventDefault();
        }

        if (t.current) return true;

        this.setChatroomActive(t, true);
        
        const all = _.map(
            this.getActiveAndRecent(),
            (c) => { c.current = false; return c; }
        );
        const tt = _.find(all, { id: t.id});
        tt.current = true;

        // Check for project admin permissions if this is a project chatroom
        if (tt.section === 'project') {
            // Check if we already have cached the permissions for this project
            if (this.projectAdminCache[tt.refId] !== undefined) {
                this.completeGoChat(tt, this.projectAdminCache[tt.refId]);
            } else {
                // Retrieve project permissions before activating chat
                this.userRest.getPermissions(this.currentUser.unixName, { projectId: tt.refId })
                    .then((response) => {
                        const isAdmin = _.get(response, 'isAdmin', false);
                        this.projectAdminCache[tt.refId] = isAdmin;
                        this.completeGoChat(tt, isAdmin);
                    }, (error) => {
                        this.completeGoChat(tt, false);
                    });
                return; // Return early - we'll complete the chat activation after permissions are fetched
            }
        } else {
            // Not a project chatroom
            this.completeGoChat(tt, false);
        }
    };

    /**
     * Finish switching to a room, now that its permissions are known.
     *
     * The flag is handed in rather than read off the view: rooms are open side
     * by side and a user is not the same thing in each of them, so the right
     * to delete other people's messages belongs to the room, not to the
     * screen. It is also what keeps two overlapping switches -- one waiting on
     * a permissions call, one answered from the cache -- from crossing wires.
     */
    completeGoChat(tt, isProjectAdmin = false) {
        this.closeLeftSidebar();

        // User is admin if they're a site admin OR a project admin for this project
        tt.isAdmin = this.isSiteAdmin || isProjectAdmin;

        // This is used to let directive know it's the current chatroom on screen
        this.notificationService.notifyAll('GFCHAT_CURRENT_CHATROOM', tt);
        this.titleService.setTitle(tt.name, this.siteName);
    }

    /**
     * Rooms opened from the Projects/Orgs lists start out without a thread
     * id; the room's gf-chat reports it once /api/forum/x/chat resolves it,
     * so that removeRecent() can find the room's preference later.
     */
    setChatroomThread(t, threadId) {
        if (threadId) {
            t.threadId = threadId;
        }
    }

    closeChatroom(t, $ev) {

        if ($ev) {
            $ev.stopPropagation();
            $ev.preventDefault();
        }

        // Taking the room out of the active list destroys its gf-chat, which
        // stops the room's polls itself (see GfChatComponent.stopChatPoll).
        this.setChatroomActive(t, false);

        const wasCurrent = !!t.current;
        t.current = false;

        if (wasCurrent && this.activeChatrooms.length) {
            this.goChatroom(this.activeChatrooms[0]);
        }

        return this.httpClient.post(
            '/api/forum/x/userOffline',
            { 'section': t.section, 'refId': t.refId }
        ).toPromise();
    };

    removeRecent(t, $ev) {

        if ($ev) {
            $ev.stopPropagation();
            $ev.preventDefault();
        }

        this.userService.preference.deletePreference('chat-room-' + t.threadId)
        .then(
            () => {
                this.recentChatrooms = this.recentChatrooms.filter((item) => item !== t);
            },
            (result) => {
                console.log(result);
            }
        );
    };

    sectionToggle(icon) {
        var el = '#' + icon;
        if ($(el).hasClass('glyphicon-chevron-down')) {
            $(el).removeClass('glyphicon-chevron-down');
            $(el).addClass('glyphicon-chevron-right');
        } else {
            $(el).removeClass('glyphicon-chevron-right');
            $(el).addClass('glyphicon-chevron-down');
        }
    };

    closeLeftSidebar() {
        setTimeout(() => {
            $('#chat-left-sidebar').removeClass('sidebar-open');
        }, 250);
    }

    trackById(index: number, item: any): any {
        return item.id;
    }
}
